import $ from 'jquery';
import load_slick from '../libs/slick';

export default {
    init() {
    },

    finalize() {
        $(window).on('load', function () {
            load_slick('.slider-home');
        });
    },

};



// WEBPACK FOOTER //
// ./scripts/routes/home.js